import React, { useEffect, useRef, useState } from "react";
import "./CustomCursor.css";

const CustomCursor = () => {
  const cursorDot = useRef(null);
  const cursorOutline = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dot = cursorDot.current;
    const outline = cursorOutline.current;

    let mouseX = 0;
    let mouseY = 0;
    let outlineX = 0;
    let outlineY = 0;
    const speed = 0.2;

    const updateCursor = () => {
      outlineX += (mouseX - outlineX) * speed;
      outlineY += (mouseY - outlineY) * speed;

      dot.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
      outline.style.transform = `translate3d(${outlineX}px, ${outlineY}px, 0)`;

      requestAnimationFrame(updateCursor);
    };

    const mouseMove = (e) => {
      if (!isVisible) setIsVisible(true);
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const handleMouseEnter = () => {
      outline.classList.add("cursor-hovered");
      dot.classList.add("cursor-dot-hovered");
    };

    const handleMouseLeave = () => {
      outline.classList.remove("cursor-hovered");
      dot.classList.remove("cursor-dot-hovered");
    };

    const addHoverListeners = () => {
      const hoverables = document.querySelectorAll("a, button, .cursor-hover");
      hoverables.forEach((el) => {
        el.addEventListener("mouseenter", handleMouseEnter);
        el.addEventListener("mouseleave", handleMouseLeave);
      });
    };

    const removeHoverListeners = () => {
      const hoverables = document.querySelectorAll("a, button, .cursor-hover");
      hoverables.forEach((el) => {
        el.removeEventListener("mouseenter", handleMouseEnter);
        el.removeEventListener("mouseleave", handleMouseLeave);
      });
    };

    document.addEventListener("mousemove", mouseMove);
    addHoverListeners();
    requestAnimationFrame(updateCursor);

    return () => {
      document.removeEventListener("mousemove", mouseMove);
      removeHoverListeners();
    };
  }, [isVisible]);

  return (
    <>
      <div 
        ref={cursorDot} 
        className="cursor-dot" 
        style={{ opacity: isVisible ? 1 : 0 }} 
      />
      <div 
        ref={cursorOutline} 
        className="cursor-outline" 
        style={{ opacity: isVisible ? 1 : 0 }} 
      />
    </>
  );
};

export default CustomCursor;

